// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-thumb {
  max-width: 140px;
  max-height: 105px;
  width: 140px;
  height: 105px;
  background-color: var(--mc-skeleton-block-bg);
  margin-right: 12px;
  float: left;
  border-radius: 4px;
}
.summary-thumb app-skeleton {
  max-width: 140px;
  max-height: 105px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/skeleton/skeleton.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,6CAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AACJ;AACI;EACI,gBAAA;EACA,iBAAA;AACR","sourcesContent":[".summary-thumb {\r\n    max-width: 140px;\r\n    max-height: 105px;\r\n    width: 140px;\r\n    height: 105px;\r\n    background-color: var(--mc-skeleton-block-bg);\r\n    margin-right: 12px;\r\n    float: left;\r\n    border-radius: 4px;\r\n\r\n    app-skeleton {\r\n        max-width: 140px;\r\n        max-height: 105px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
